import React from 'react';
import { CircularProgress } from '@mui/material';

interface LoadingProps {
    message?: string;
    size?: 'sm' | 'md' | 'lg';
}

const spinnerSizes = {
    sm: 24,
    md: 36,
    lg: 48,
};
const textSizes = {
    sm: 15,
    md: 18,
    lg: 20,
};

const Loading: React.FC<LoadingProps> = ({ message, size = 'lg' }) => (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', padding: '10px' }}>
        <CircularProgress color="primary" size={spinnerSizes[size] || spinnerSizes.lg} />
        <div
            style={{
                marginLeft: size === 'sm' ? 12 : 16,
                fontSize: textSizes[size] || textSizes.lg,
                color: '#333',
            }}
        >
            {message || 'Loading...'}
        </div>
    </div>
);

export default Loading;
